// extracted by mini-css-extract-plugin
export default {"mobileNav":"MobileNavbar_mobileNav__-xyxF"};